import { useContext } from 'react';

import InformationContext from '../context';

function useInformation() {
  const context = useContext(InformationContext);

  if (!context) {
    throw new Error('useInformation must be used within InformationProvider');
  }

  return context;
}

export default useInformation;